const usersTypes = {
  USERS_LIST_SET: 'USERS_LIST_SET',
  USERS_TABLE_LOADING: 'USERS_TABLE_LOADING',
  USER_DETAILS_SET: 'USER_DETAILS_SET',
  USER_DELETE: 'USER_DELETE',
};
export default usersTypes;
